import { registerLocaleData } from '@angular/common';

import { HttpClient } from '@angular/common/http';
import { MultiTranslateHttpLoader } from './services/utils/multi-translate-http-loader';

import localePT from '@angular/common/locales/pt';
registerLocaleData(localePT);

import localeES from '@angular/common/locales/es';
registerLocaleData(localeES);

import localeFR from '@angular/common/locales/fr';
registerLocaleData(localeFR);

export function httpTranslateLoader(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/i18n/', suffix: '/core.json' },
    { prefix: './assets/i18n/', suffix: '/map.json' },
    { prefix: './assets/i18n/', suffix: '/admin.json' },
    { prefix: './assets/i18n/', suffix: '/interface.json' },
  ]);
}
